import { render, staticRenderFns } from "./question-selector.vue?vue&type=template&id=fb33abb6&scoped=true&"
import script from "./question-selector.vue?vue&type=script&lang=js&"
export * from "./question-selector.vue?vue&type=script&lang=js&"
import style0 from "./question-selector.vue?vue&type=style&index=0&id=fb33abb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb33abb6",
  null
  
)

export default component.exports